import { React, useContext, useState, useEffect, useRef } from 'react'
import { format, isValid } from 'date-fns';
import axios from 'axios';
import '../../../CssFiles/bureau.css'
import { getIST } from '../bureauUtils';

import safetyIcon from '../../../Images/bureauImages/safetyIcon.png'
import backArrow from '../../../Images/bureauImages/backArrow.png'
import { BureauContext } from '../HomePage';
import rupeeIcon from '../../../Images/helloTradeImages/RupeeIcon.png'
import logo from '../../../Images/helloTradeImages/HelloTradeLogo.png'
import BenefitsComponent from './BenefitsComponent';
const fullNameRegex = /^[A-Za-z\s]+$/;
const fullPanRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
const BusinessRegex = /^[a-zA-Z0-9. ]+$/;

function PiComponent() {

    const { setDisplayPage, setOtpScreen, userInfo, setUserInfo, phoneError, setPhoneError, defaultUserInfo, setDefaultUserInfo, token, gstAvailable } = useContext(BureauContext);

    const [isChecked, setIsChecked] = useState(true);
    const [isValidName, setIsValidName] = useState(true);
    const [isValidBusiName, setIsValidBusiName] = useState(true);
    const [isValidPan, setIsValidPan] = useState(true);
    const [isValidMob, setIsValidMob] = useState(true);
    const [checkBoxWarning, setCheckBoxWarning] = useState(false);
    const [inputValue, setInputValue] = useState(userInfo.dob);
    const [isValidDate, setIsValidDate] = useState(true);
    const [age, setAge] = useState(22);
    const [ageErr, setAgeErr] = useState(false);
    const dateInputRef = useRef(null);
    const datePickerRef = useRef(null);
    const [enteringPan, setEnteringPan] = useState(true);
    const [perPan, setPerPan] = useState(true);
    const [isClickCapture, setIsClickCapture] = useState(false);

    const handleNameChange = (e) => {
        const value = e.target.value;
        setIsValidName(fullNameRegex.test(value));
        setUserInfo((prevInfo) => ({ ...prevInfo, name: value }));
    };

    const handlePanChange = (e) => {
        const input = e.target;
        const cursorPosition = input.selectionStart;

        const value = e.target.value.trim().toUpperCase();
        const isValidSubstring = validatePanSubstring(value);

        setEnteringPan(isValidSubstring);

        if (value.length == 10) {
            checkValidPan(value);
        } else {
            if (isValidPan) {
                setIsValidPan(false);
            }
        }

        setUserInfo((prevInfo) => ({ ...prevInfo, pan: value }));


        input.setSelectionRange(cursorPosition, cursorPosition);
    };

    const handleMobChange = (e) => {
        const value = e.target.value;
        setUserInfo((prevInfo) => ({ ...prevInfo, updatedMob: value, maskedMob: '' }));
        const isValidMobile = /^[0-9]{0,10}$/.test(value);
        setIsValidMob(isValidMobile);
        if (phoneError) {
            setPhoneError(false);
        }
    };

    const handleMobKey = (e) => {
        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Enter') {
            e.preventDefault();
        }
    };

    const handleCheckClick = () => {
        setIsChecked(prevState => {
            const newState = !prevState;
            console.log("setting isChecked to", newState);
            if (newState) {
                setCheckBoxWarning(false)
            }
            return newState;
        });
    }

    const handleOtpClick = () => {
        let valid = true;
        if (!userInfo.name || !isValidName) {
            setIsValidName(false);
            valid = false;
        }


        if (!checkValidPan(userInfo.pan)) {
            setIsValidPan(false);
            valid = false;
        }

        if (!isValidMob || userInfo.updatedMob.length != 10) {
            setIsValidMob(false);
            valid = false;
        }

        if (!isChecked) {
            console.log("Please check the declaration checkbox, currently checkbox is => ", isChecked);
            valid = false;
            setCheckBoxWarning(true);
        }

        // handleBureauConnect();

        if (valid) {
            const currentIST = getIST();
            setUserInfo((prevInfo) => ({ ...prevInfo, otpTime: currentIST }))
            handleBureauConnect();
            captureIntentClick()
        } else {
            console.log("Please ensure all fields are valid and the checkbox is checked.");
        }
    };

    const captureIntentClick = () => {
        var host = window.location.hostname;

        if (host == 'www.hellotrade.com') {
            var apiURL = "https://loans.indiamart.com/api/v1/captureClick";
        }
        else {
            var apiURL = "https://dev-loans.indiamart.com/api/v1/captureClick";
        }
        var inData = {
            "glid": userInfo.glid,
            "bname": userInfo.busiName,
            "iname": userInfo.name,
            "pan": userInfo.pan,
            "updatedMob": userInfo.updatedMob,
            "loanamt": " 5 Lakh",
            "src":"HelloTrade"
        };

        var formData = new FormData();
        for (var key in inData) {
            formData.append(key, inData[key]);
        }

        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'x-api-key': token },
            url: apiURL,
            data: formData,
            timeout: 2000
        }).then(function (response) {
            //console.log(response.data);
            if (response.data.CODE == "200") {
                setIsClickCapture(true);
            }
        })
    };

    const handleBureauConnect = () => {
        const host  = window.location.hostname;

        const apiKey = host == "www.hellotrade.com"?'98fdeef1a7c14ea3972320a6169838ce':'e1a7232a8c5145b99d34135cefd1ad30';
        const customerId = userInfo.glid;
        const firstName = userInfo.fn;
        const middleName = userInfo.mn;
        const lastName = userInfo.ln;
        const phone = userInfo.updatedMob;

        //    const customerId = '192395864';
        //     const firstName = 'Aviral';
        //     const middleName = '';
        //     const lastName = 'Panwar';
        //     const phone = '7668945130';

        console.log("In handle Bureau func id, fn, mn, ln, phone => ",customerId , firstName , middleName, lastName, phone);

        if (window.getBureauSession) {
            console.log("In getBureauSession")
            window.getBureauSession(apiKey, customerId, firstName, middleName, lastName, phone)
                .then((bureauSession) => {
                    if (bureauSession) {
                        console.log("URl=> ", bureauSession)
                        setOtpScreen(bureauSession);
                        setDisplayPage(2);
                    } else {
                        console.error('Not getting bureau session');
                    }
                })
                .catch((error) => {
                    setPhoneError(true)
                    console.log('Session initiation error:', error);
                });
        }

    };

    const handleDobInputChange = (e) => {
        let value = e.target.value;
        const cursorPosition = e.target.selectionStart;
        const keyPressed = e.nativeEvent.inputType;
        const isBackspace = keyPressed === 'deleteContentBackward';

        const sanitizedValue = value.replace(/[^0-9-]/g, '');
        let formattedValue = sanitizedValue;

        if (isBackspace) {

        } else {
            if (sanitizedValue.length === 2 && sanitizedValue[2] !== '-') {
                formattedValue = sanitizedValue.slice(0, 2) + '-' + sanitizedValue.slice(2);
            }
            if (sanitizedValue.length === 5 && sanitizedValue[5] !== '-') {
                formattedValue = sanitizedValue.slice(0, 5) + '-' + sanitizedValue.slice(5);
            }

            if ((keyPressed === 'insertText' && ['-', '/'].includes(e.nativeEvent.data)) || keyPressed === 'insertFromPaste') {
                const beforeCursor = sanitizedValue.slice(0, cursorPosition - 1);
                const afterCursor = sanitizedValue.slice(cursorPosition);
                if (beforeCursor.length === 1) {
                    formattedValue = '0' + beforeCursor + '-' + afterCursor;
                } else if (beforeCursor.length === 4) {
                    formattedValue = beforeCursor.slice(0, 3) + '0' + beforeCursor.slice(3) + '-' + afterCursor;
                }
            }

            // Prevent extra dashes from being added during re-entry
            if (sanitizedValue[cursorPosition - 1] === '-' && cursorPosition < sanitizedValue.length) {
                formattedValue = sanitizedValue;
            }
        }

        // Limit length to "dd-mm-yyyy"
        value = formattedValue.slice(0, 10);

        setInputValue(value);
        setUserInfo((prevInfo) => ({ ...prevInfo, dob: value }));

        // Adjust cursor position after formatting
        requestAnimationFrame(() => {
            const inputElement = e.target;
            let adjustedCursorPosition = cursorPosition;

            // Move cursor forward if a dash was added automatically
            if (!isBackspace && formattedValue.length > sanitizedValue.length) {
                if (cursorPosition === 2 || cursorPosition === 5) {
                    adjustedCursorPosition++;
                }
            }

            // Move cursor back if a dash was deleted
            if (isBackspace && formattedValue.length < sanitizedValue.length) {
                if (cursorPosition === 3 || cursorPosition === 6) {
                    adjustedCursorPosition--;
                }
            }

            inputElement.setSelectionRange(adjustedCursorPosition, adjustedCursorPosition);
        });

        const [dayStr = '', monthStr = '', yearStr = ''] = value.split('-');

        const dayStrLen = dayStr.length;
        const monthStrLen = monthStr.length;
        const yearStrLen = yearStr.length;

        // console.log("all length => ", dayStrLen, monthStrLen, yearStrLen)

        const [day, month, year] = value.split('-').map(Number);
        //console.log("Day in handleChange = >", day, "month => ", month);

        if ((dayStrLen == 0) || (day != undefined && dayStrLen >= 2 && (day > 31 || day < 1)) || (month != undefined && monthStrLen >= 2 && (month > 12 || month < 1)) || (year != undefined && yearStrLen >= 4 && (year < 1)) || ((dayStrLen == 0 || day == 0) && monthStrLen != 0) || ((monthStrLen == 0 || month == 0) && yearStrLen != 0) || (month == 2 && day > 29)) {
            setIsValidDate(false);
        } else {
            if (!isValidDate) {
                setIsValidDate(true);
            }
        }

        //if (year) { console.log("year length =>", year.toString().length, year) }

        //console.log("day month and year => ", day, month, year)
        if (day && month && year && yearStrLen == 4) {
            //console.log("In valid date checks ")
            if (checkValidDate(value)) {
                if (!isValidDate) {
                    setIsValidDate(true);
                }
            } else {
                if (isValidDate) {
                    setIsValidDate(false);
                }
            }

            if (checkAge(value)) {
                if (ageErr) {
                    setAgeErr(false);
                }
            } else {
                if (!ageErr) {
                    setAgeErr(true);
                }
            }

        } else {
            setAgeErr(false);
        }
    };

    const handleDobKeyDown = (e) => {
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '-', '/'];
        if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleNameKey = (e) => {
        if (fullNameRegex.test(e.key) || e.key === "Backspace" || e.key === "Delete" || e.key == " ") {
            return;
        }
        e.preventDefault();
    }

    const checkValidDate = (inputDate) => {
        const today = new Date();
        const [day, month, year] = inputDate.split('-').map(Number);
        //console.log("Date in check Valid => ",day, month, year)

        const inputDateObject = new Date(year, month - 1, day);

        if (isNaN(inputDateObject) || inputDateObject > today) {
            return false;
        }

        if (year == 0) {
            return false;
        }

        if (month < 1 || month > 12) return false;

        if (day < 1 || day > 31) return false;

        const daysInMonth = new Date(year, month, 0).getDate();
        if (day > daysInMonth) return false;

        if (month === 2 && day > 29) {
            if ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) {
                return true;
            }
            return false;
        }
        // console.log("returning true");
        return true;
    };

    const checkAge = (inputDate) => {
        //console.log("In check age");
        const today = new Date();
        const [day, month, year] = inputDate.split('-').map(Number);
        const birthDate = new Date(year, month - 1, day);

        let age = today.getFullYear() - birthDate.getFullYear();

        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
        ) {
            age -= 1;
        }

        // console.log("Age is => ", age);
        setAge(age);

        if (age < 21 || age > 60) {
            // console.log("Setting less age to true");
            setAgeErr(true);
            return false;
        } else if (ageErr) {
            setAgeErr(false);
        }

        return true;
    };

    const handleCalendarClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setOpen(true);
        }
    };

    const handleDobChange = (date) => {
        if (date && isValid(date)) {

            let dateVal = format(date, 'dd-MM-yyyy')
            checkAge(dateVal);
            setUserInfo((prevInfo) => ({ ...prevInfo, dob: dateVal }));
            setInputValue(dateVal);
            if (!isValidDate) {
                setIsValidDate(true);
            }
        } else {
            setUserInfo((prevInfo) => ({ ...prevInfo, dob: "" }));
            setInputValue('');
        }
    };

    const handleBusinessChange = (e) => {
        const value = e.target.value;
        setIsValidBusiName(BusinessRegex.test(value));
        setUserInfo((prevInfo) => ({ ...prevInfo, busiName: value }));
    };

    const handleBusinessKey = (e) => {
        console.log(e)
        if (BusinessRegex.test(e.key) || e.key === "Backspace" || e.key === "Delete" || e.key === ".") {
            return;
        }
        e.preventDefault();
    }

    const handlePanKey = (e) => {
        const isAlphaNumeric = /^[a-zA-Z0-9]$/.test(e.key);

        if (!isAlphaNumeric && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
            e.preventDefault();
        }
    }

    const checkValidPan = (value) => {
        if (value.length == 10 && /[A-Z]/.test(value.charAt(3)) && value.charAt(3) != 'P') {
            if (perPan) {
                setPerPan(false);
            }
        } else {
            if (!perPan) {
                setPerPan(true);
            }
        }

        if (value.length == 10 && value.charAt(3) == 'P' && fullPanRegex.test(value)) {
            if (!isValidPan) {
                setIsValidPan(true);
            }

            if (!enteringPan) {
                setEnteringPan(true)
            }
            return true;
        }
        if (isValidPan) {
            setIsValidPan(false);
        }
        if (enteringPan) {
            setEnteringPan(false)
        }
        return false;
    }

    const validatePanSubstring = (value) => {
        const length = value.length;

        if (length >= 4 && /[A-Z]/.test(value.charAt(3)) && value.charAt(3) !== 'P') {
            if (perPan) {
                setPerPan(false);
            }
            return false;
        } else {
            if (!perPan) {
                setPerPan(true);
            }
        }

        if (length === 1 || length === 2 || length === 3 || length === 4 || length == 5) {
            return /^[A-Z]{0,5}$/.test(value);
        }


        if (length >= 6 && length <= 9) {
            return /^[A-Z]{5}[0-9]{0,4}$/.test(value);
        }

        if (length === 10) {
            return /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value);
        }

        return false; // Invalid length or condition
    };

    const handlePanInput = (e) => {
        const input = e.target;
        const start = input.selectionStart; // Capture the cursor position
        const end = input.selectionEnd;

        // Transform the input value to uppercase
        input.value = input.value.toUpperCase();

        // Restore the cursor position
        input.setSelectionRange(start, end);
    }

    return (
        <>
            <div id='pi-parent'>
                <div className='pi'>
                    <div className='pi-header'>
                        {/* <span id='back-arrow-parent'><img src={backArrow} style={{ width: '16px' }} /></span> */}
                        {/* <span id='header-text'>Let's Get Your CIBIL</span> */}
                        <div className='header logo bureauHeader'>
                            <img src={rupeeIcon} id="rupeeIcon" />
                            <img src={logo} id="logoIcon" />
                        </div>
                    </div>

                    <div className="progress-bar">
                        <div className="progress-indicator"></div>
                    </div>

                    <div style={{ background: 'linear-gradient(24deg, rgb(0, 178, 164), rgb(128, 226, 214))', fontFamily: 'Manrope', padding: '10px', color: '#FFFFFF' }}>
                        <div style={{ fontWeight: '700', fontSize: '20px' }}>Get Business Loan in 2 steps!</div>
                        <div>- From RBI Approved Bank/NBFC</div>
                        <div>- Loan Upto 50 Lakh</div>
                    </div>

                    <div className='form-parent'>
                        {gstAvailable ? <>
                            <div className="container form-container" id='pi-form'>

                                {
                                    userInfo.busiName != "" &&
                                    <div className='comp-name-div'>Company Name - {userInfo.busiName}</div>
                                }

                                <div className="row">

                                    {/* <div className="col-12 col-md-6 form-field">
        
        <label>Business Name</label>
        <input type="text" placeholder='Enter Business Name' className="input-readonly form-control" value={userInfo.busiName} onChange = {handleBusinessChange} onKeyDown={handleBusinessKey} 
        readOnly={defaultUserInfo.busiName && defaultUserInfo.busiName.length > 0 && isValidBusiName} 
        style={{cursor:defaultUserInfo.busiName && defaultUserInfo.busiName.length > 0 && isValidBusiName ? 'not-allowed' : ''}}
        />
        {!isValidBusiName && <div className='warning'>Please Enter valid Business Name</div>}
    </div> */}
                                    {/* <div>{defaultUserInfo.busiName}</div> */}
                                    <div className="col-12 col-md-6 form-field">
                                        <label>Your Name</label>
                                        <input type="text" placeholder='Enter Name' className="input-readonly form-control"
                                            readOnly={defaultUserInfo.name && defaultUserInfo.name.length > 0 && isValidName}
                                            onChange={handleNameChange}
                                            onKeyDown={handleNameKey}
                                            value={userInfo.name}
                                            style={{ cursor: defaultUserInfo.name && defaultUserInfo.name.length > 0 && isValidName ? 'not-allowed' : '' }} />
                                        {!isValidName && <div className='warning'>Please Enter Valid Name</div>}
                                    </div>

                                    <div className="col-12 col-md-6 form-field">
                                        <label>Your PAN</label>
                                        <input
                                            type="text"
                                            placeholder="Enter PAN"
                                            className="input-readonly form-control"
                                            maxLength={10}
                                            style={{
                                                textTransform: 'uppercase',
                                                cursor: defaultUserInfo.pan && defaultUserInfo.pan.length > 0 && isValidPan ? 'not-allowed' : ''
                                            }}
                                            value={
                                                defaultUserInfo.pan.length == 10
                                                    ? `${userInfo.pan[0]}***${userInfo.pan[3] || '*'}${userInfo.pan[4] || '*'}****${userInfo.pan[9] || '*'}`
                                                    : userInfo.pan
                                            }
                                            readOnly={defaultUserInfo.pan && defaultUserInfo.pan.length > 0 && isValidPan}
                                            onChange={handlePanChange}
                                            onKeyDown={handlePanKey}
                                            onInput={handlePanInput}
                                        />

                                        {!enteringPan && perPan && <div className='warning'>Please Enter Valid PAN No.</div>}
                                        {!perPan && <div className='warning'>Please Enter Personal PAN No.</div>}
                                    </div>
                                </div>

                                <div className='row' style={{ marginTop: '15px' }}>

                                    <div className="col-12 col-md-6 form-field">
                                        <label>Mobile Number</label>
                                        <input
                                            type="tel"
                                            placeholder="Enter Mobile"
                                            className="input-readonly form-control"
                                            maxLength={10}
                                            value={userInfo.maskedMob || userInfo.updatedMob}
                                            readOnly={defaultUserInfo.updatedMob && defaultUserInfo.updatedMob.length > 0 && isValidMob}
                                            onChange={handleMobChange}
                                            onKeyDown={handleMobKey}
                                            style={{ cursor: defaultUserInfo.updatedMob && defaultUserInfo.updatedMob.length > 0 && isValidMob ? 'not-allowed' : 'pointer' }}
                                        />
                                        {!isValidMob && <div className='warning'>Enter a valid Mobile</div>}
                                    </div>

                                    <div className="col-12 col-md-6 form-field"></div>
                                </div>

                                <div className='declaration-parent'>
                                    <div className='declaration'>
                                        <div className="checkbox-container">
                                            <div className="checkbox-container" onChange={handleCheckClick}>
                                                <input type="checkbox" id="custom-checkbox" defaultChecked />
                                                <label htmlFor="custom-checkbox"></label>
                                            </div>
                                        </div>
                                        <div id='text'>I agree to HelloTrade's<span>Privacy Policy</span> and <span>T&Cs</span>. I also authorize the platform to contact me for my loan application.</div>
                                    </div>
                                    {checkBoxWarning && <div className='warning'>Click on the checkbox</div>}
                                </div>

                            </div>

                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>{phoneError && <div className='warning' style={{ marginTop: '25px' }}>Something went wrong. Please try again after sometime!</div>}</div>

                            <div className='otp-button' onClick={handleOtpClick}>
                                Get Offer
                            </div>
                        </> :
                            <><div>Please update your GST Details on Indiamart's Portal.</div></>}


                        <div className='safety'>
                            <img src={safetyIcon} />
                            <div id='safety-text'>Your data is 100% safe & secure</div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default PiComponent
